import { useFilterPanel } from './FilterPanelContext'
import { AppSelectSearchable } from 'components/atoms/AppSelectSearchable/AppSelectSearchable'
import { FilterTag } from 'components/atoms/FilterTag/FilterTag'

export interface SearchableOption {
    value: string
    label: string
}

interface Props {
    name: string
    label: string
    options: SearchableOption[]
    disabled?: boolean
}

/**
 * Searchable select section for the filters panel. Reuses AppSelectSearchable
 * (same component as the order creation form) and shows the selection as a
 * removable chip, wired through the FilterPanel context.
 */
export const FilterSearchableSelect = ({ name, label, options, disabled }: Props) => {
    const { values, setValue, clearValue } = useFilterPanel()
    const selected = (values[name] as string) ?? ''
    const selectedLabel = options.find((o) => o.value === selected)?.label ?? ''

    const clear = () => {
        clearValue(name)
        clearValue(`${name}__meta`)
    }

    const handleChange = (value: string) => {
        setValue(name, value)
        const meta = options.find((o) => o.value === value)
        if (meta) setValue(`${name}__meta`, { name: meta.label })
    }

    return (
        <div className="flex flex-col gap-[8px]">
            <div className="flex flex-col gap-[4px]">
                <div className="flex items-center justify-between">
                    <span className="text-[14px] leading-[18px] text-[#3E5060]">{label}</span>
                    {selected && (
                        <button
                            type="button"
                            onClick={clear}
                            className="text-[14px] leading-[18px] font-semibold text-[#568C13] hover:text-green-700"
                        >
                            Limpiar
                        </button>
                    )}
                </div>
                <AppSelectSearchable
                    value={selected}
                    onChange={handleChange}
                    options={options}
                    placeholder="Seleccionar"
                    isSearchable
                    disabled={disabled}
                />
            </div>

            {selected && (
                <div className="flex flex-wrap gap-2">
                    <FilterTag label={selectedLabel} onRemove={clear} />
                </div>
            )}
        </div>
    )
}
